import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import heroImage from '../assets/main1.png';

export default function QuiSommesNousPage() {
  // 1. État pour le tracking du scroll (Parallaxe)
  const [offsetY, setOffsetY] = useState(0);

  // 2. Écouteur de scroll pour la parallaxe
  useEffect(() => {
    const handleScroll = () => setOffsetY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const team = [
    { name:'Florent D.', role:'Fondateur & directeur', emoji:'👤' },
    { name:'Équipe RÉSAM', role:'Réseau national', emoji:'🌿' },
  ];
  
  const values = [
    { icon:'👁️', title:'Observer', desc:'Lire le territoire, comprendre l\'espace, développer une conscience du lieu.' },
    { icon:'🧠', title:'Analyser', desc:'Combiner intelligence collective, orientation et stratégie d\'équipe.' },
    { icon:'🤝', title:'Agir ensemble', desc:'La coopération comme moteur — chaque équipier compte.' },
    { icon:'👍', title:'Réussir', desc:'Célébrer chaque checkpoint, chaque effort partagé, chaque découverte.' },
  ];

  // Configurations d'animation pour Framer Motion
  const containerVariants = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: { staggerChildren: 0.15 } // Fait apparaître les cartes une par une
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 40 },
    show: { 
      opacity: 1, 
      y: 0, 
      transition: { type: "spring", stiffness: 80, damping: 15 } 
    }
  };

  return (
    <div style={{ paddingTop:'var(--nav-h, 64px)', overflow:'hidden' }}>
      
      {/* STYLE POUR LA PARALLAXE RESPONSIVE (Même que LancerVotreRadar) */}
      <style>{`
        .qsn-parallax-img {
          position: absolute;
          top: 5%;
          right: 5%;
          width: 450px;
          pointer-events: none;
          z-index: 0;
          opacity: 0.35;
          filter: contrast(0.9) brightness(1.2);
          transition: transform 0.1s ease-out;
        }

        .qsn-text-container {
          max-width: 1100px;
          margin: 0 auto;
          position: relative;
          z-index: 1;
        }

        @media (max-width: 768px) {
          .qsn-parallax-img {
            width: 150%;
            right: -25%;
            top: 15%;
            opacity: 0.1;
          }
          .qsn-text-container {
            background: radial-gradient(circle, rgba(26,10,0,0.85) 0%, rgba(26,10,0,0) 70%);
            padding: 20px 0;
          }
        }
      `}</style>

      {/* Hero */}
      <section style={{ padding:'clamp(40px,7vw,80px) var(--px,clamp(16px,5vw,40px))', background:'#1A0A00', color:'#fff', position:'relative', overflow:'hidden' }}>
        
        {/* Cercles décoratifs */}
        <div style={{ position:'absolute', top:'50%', right:'-8%', width:'40vw', height:'40vw', border:'1px solid rgba(217,79,0,.2)', borderRadius:'50%', transform:'translateY(-50%)', pointerEvents:'none', zIndex: 0 }} />
        
        {/* IMAGE PARALLAXE RESPONSIVE */}
        <img 
          src={heroImage}
          alt="Floating visual"
          className="qsn-parallax-img"
          style={{ transform: `translateY(${offsetY * 0.4}px)` }}
        />

        {/* CONTENEUR TEXTE PROTÉGÉ */}
        <div className="qsn-text-container">
          <p style={{ fontFamily:'Space Mono,monospace', fontSize:10, color:'rgba(217,79,0,.8)', letterSpacing:'.14em', textTransform:'uppercase', marginBottom:20 }}>À propos</p>
          <h1 style={{ fontSize:'clamp(36px,5.5vw,68px)', fontWeight:700, letterSpacing:'-.03em', lineHeight:1.05, marginBottom:28, maxWidth:640 }}>
            Qui sommes-nous ?
          </h1>
          <p style={{ fontSize:18, color:'rgba(255,255,255,.65)', maxWidth:520, lineHeight:1.65 }}>
            Le Résam, une association au service des associations du pays de Morlaix.

Le Résam est à la fois un réseau (plus de 200 adhérents) et un service pour les associations du territoire. Son rôle est de soutenir, d’accompagner et de valoriser les associations du pays de Morlaix pour construire les conditions les plus efficientes à la mise en œuvre de leurs projets.
Il est un lieu de conseil et de diffusion d’informations. Il favorise la mutualisation des moyens, des connaissances et entretient le lien entre les associations du territoire.
          </p>
        </div>
      </section>

      {/* Mission */}
      <section style={{ padding:'clamp(40px,7vw,80px) var(--px,clamp(16px,5vw,40px))', background:'#fff' }}>
        <div style={{ maxWidth:900, margin:'0 auto' }}>
          <p className="section-label" style={{ marginBottom:16 }}>Notre mission</p>
          <h2 style={{ fontSize:'clamp(24px,4vw,36px)', fontWeight:700, letterSpacing:'-.02em', marginBottom:28, lineHeight:1.2 }}>
            Connecter les gens à leur territoire<br />par le mouvement et la coopération
          </h2>
          <p style={{ fontSize:17, color:'#3D5550', lineHeight:1.8, marginBottom:20 }}>
            RADAR peut se jouer à tous les âges, sur toutes les durées et sur tous les territoires. Vous voulez organiser un RADAR chez vous? Contactez-nous via animation@resam.net.
          </p>
          <p style={{ fontSize:17, color:'#3D5550', lineHeight:1.8 }}>
            Un jeu de piste pour aller à la rencontre des structures du territoire
            
          </p>
        </div>
      </section>

      {/* Values - AVEC ANIMATIONS FRAMER MOTION */}
      <section style={{ padding:'clamp(40px,7vw,80px) var(--px,clamp(16px,5vw,40px))', background:'var(--radar-cream)' }}>
        <div style={{ maxWidth:1100, margin:'0 auto' }}>
          <p className="section-label" style={{ marginBottom:16 }}>Nos valeurs</p>
          <h2 style={{ fontSize:'clamp(22px,4vw,34px)', fontWeight:700, letterSpacing:'-.02em', marginBottom:48 }}>4 piliers qui guident RADAR</h2>
          
          <motion.div 
            variants={containerVariants}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.2 }} // Se déclenche quand 20% de la section est visible
            style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(220px,1fr))', gap:24 }}
          >
            {values.map((v,i) => (
              <motion.div 
                key={i} 
                variants={itemVariants}
                whileHover={{ y: -8, scale: 1.02, boxShadow: '0 16px 40px rgba(0,0,0,0.08)' }} // Effet doux au survol
                style={{ background:'#fff', border:'1px solid rgba(122,140,136,.18)', borderRadius:8, padding:'28px 24px', cursor: 'default', transition: 'box-shadow 0.3s ease' }}
              >
                <div style={{ fontSize:36, marginBottom:14 }}>{v.icon}</div>
                <h3 style={{ fontSize:18, fontWeight:700, marginBottom:10, color:'var(--radar-dark)' }}>{v.title}</h3>
                <p style={{ fontSize:14, color:'#5A6B68', lineHeight:1.65 }}>{v.desc}</p>
              </motion.div>
            ))}
          </motion.div>
          
        </div>
      </section>

      {/* RÉSAM */}
      <section style={{ padding:'clamp(40px,7vw,80px) var(--px,clamp(16px,5vw,40px))', background:'var(--radar-deep)', color:'#fff' }}>
        <div style={{ maxWidth:900, margin:'0 auto', display:'grid', gridTemplateColumns:'1fr 1fr', gap:60, alignItems:'center' }}>
          <div>
            <p style={{ fontFamily:'Space Mono,monospace', fontSize:10, color:'rgba(255,255,255,.5)', letterSpacing:'.12em', textTransform:'uppercase', marginBottom:16 }}>Réseau</p>
            <h2 style={{ fontSize:32, fontWeight:700, letterSpacing:'-.02em', marginBottom:20 }}>Le RÉSAM</h2>
            <p style={{ fontSize:16, color:'rgba(255,255,255,.75)', lineHeight:1.7, marginBottom:24 }}>
              Jeu de piste collaboratif animé par le RESAM destiné aux 18-30 ans du territoire du Pays de Morlaix.
            </p>
            <a href="https://www.resam.net/" target="_blank" rel="noopener noreferrer" style={{ display:'inline-block', padding:'11px 24px', background:'#fff', color:'var(--radar-deep)', borderRadius:4, fontFamily:'Space Mono,monospace', fontSize:11, letterSpacing:'.05em', textTransform:'uppercase' }}>
              Visiter le RÉSAM →
            </a>
          </div>
          <div style={{ background:'rgba(255,255,255,.08)', borderRadius:12, padding:'36px 32px' }}>
            <div style={{ fontFamily:'Space Mono,monospace', fontSize:11, color:'rgba(255,255,255,.45)', marginBottom:20, textTransform:'uppercase', letterSpacing:'.1em' }}>En chiffres</div>
            {[{v:'3+',l:'Territoires actifs'},{v:'300+',l:'Participants par an'},{v:'38',l:'Équipes engagées'},{v:'2023',l:'Année de création'}].map((s,i)=>(
              <div key={i} style={{ display:'flex', justifyContent:'space-between', alignItems:'baseline', padding:'12px 0', borderBottom:i<3?'1px solid rgba(255,255,255,.08)':'none' }}>
                <span style={{ fontFamily:'Space Mono,monospace', fontSize:24, fontWeight:700, color:'#fff' }}>{s.v}</span>
                <span style={{ fontSize:12, color:'rgba(255,255,255,.5)' }}>{s.l}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <section style={{ padding:'clamp(40px,7vw,80px) var(--px,clamp(16px,5vw,40px))', background:'#fff' }}>
        <div style={{ maxWidth:600, margin:'0 auto', textAlign:'center' }}>
          <h2 style={{ fontSize:30, fontWeight:700, marginBottom:14 }}>Vous souhaitez nous rejoindre ?</h2>
          <p style={{ color:'#5A6B68', fontSize:16, marginBottom:32, lineHeight:1.6 }}>
            Que vous soyez organisateur, partenaire ou simple curieux, nous serons ravis d'échanger avec vous.
          </p>
          <div style={{ display:'flex', gap:14, justifyContent:'center', flexWrap:'wrap' }}>
            <Link to="/LancerVotreRadar" className="btn-primary">Lancer votre RADAR →</Link>
            <a href="mailto:animation@resam.net" style={{ display:'inline-block', padding:'11px 28px', border:'1.5px solid var(--radar-dark)', color:'var(--radar-dark)', fontFamily:'Space Mono,monospace', fontSize:12, letterSpacing:'.05em', textTransform:'uppercase', borderRadius:4 }}>
              Nous contacter
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}